import { RootState } from 'theSource/app/store';

export const selectEnrollmentContext = (state: RootState) => {
  if (state.enrollment.enrollmentContext.enrollmentContext === '') {
    return String(localStorage.getItem('enrollmentContext'));
  }

  return state.enrollment.enrollmentContext.enrollmentContext;
};

export const selectPreviousEnrollmentContext = (state: RootState) =>
  state.enrollment.enrollmentContext.previousEnrollmentContext;

export const selectEnrollmentOrgPlanId = (state: RootState) =>
  state.enrollment.enrollmentContext.enrollmentOrgPlanId;

export const selectEnrollmentOrgPlanYearId = (state: RootState) =>
  state.enrollment.enrollmentContext.enrollmentOrgPlanYearId;

export const selectEnrollmentOrgLifeEventId = (state: RootState) =>
  state.enrollment.enrollmentContext.enrollmentOrgLifeEventId;

export const selectHasQuestionnaire = (state: RootState) =>
  state.enrollment.enrollmentContext.hasQuestionnaire;
